import { cn } from '../../../lib/utils';

export function Container({
  type = 'column',
  children,
  className,
}: {
  type?: 'row' | 'column';
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'w-full flex bg-gscale-25',
        'rounded-lg p-2',
        type === 'column' ? 'flex-col' : 'flex-row',
        className,
      )}
    >
      {children}
    </div>
  );
}
